<template>
  <div>
    <input
        type="file"
        ref="input_foto"
        v-show="false"
        @change="changeImage"
        accept="image/*"
      />

    <as-dialogo ref="dialogoCaptureImage"
      :title="title"
      max-width="60vh"
      height="60vh"
    >
      <clipper-fixed
        :src="image"
        bg-color="white"
        :round="false"
        :rotate="rotation"
        :area="80"
        ref="clipper"
      ></clipper-fixed>
      <v-row class="pt-1">
        <v-col
          cols="12"
          sm="6"
          style="display: flex; align-items: start; justify-content: center; text-align: center; flex-direction: column"
        >
          <v-label>{{ rotationText }}</v-label>
          <clipper-range
            style="width: 100%; padding: 0px; padding-top: 8px"
            v-model="rotation"
            :min="0"
            :max="360"
          ></clipper-range>
        </v-col>
        <v-col
          cols="12"
          sm="6"
          style="display: flex; align-items: start; justify-content: center; text-align: center; flex-direction: column"
        >
          <v-label>{{ zoomText }}</v-label>
          <clipper-range
            style="width: 100%; padding: 0px; padding-top: 8px"
            v-model="zoom"
            :min="10"
            :max="200"
          ></clipper-range>
        </v-col>

        <v-col
          cols="12"
          style="align-items: end; display: flex; justify-content: flex-end;"
          class="pb-0"
        >
          <div class="pa-0">
            <v-btn depressed class="mr-4" @click="$refs.dialogoCaptureImage.fechar()"
              >Cancelar</v-btn
            >
            <v-btn depressed color="error" @click="captureImage"
              >Confirmar</v-btn
            >
          </div>
        </v-col>
      </v-row>
    </as-dialogo>
  </div>
</template>

<script>
import { clipperFixed, clipperRange } from "vuejs-clipper";

export default {
  name: 'CaptureImage',
  components: {
    clipperFixed,
    clipperRange,
  },
  props: {
    title: {
      type: String,
      default: "Ajustar Imagem"
    },
    rotationText: {
      type: String,
      default: "Rotação"
    },
    zoomText: {
      type: String,
      default: "Zoom"
    },
  },
  data() {
    return {
      zoom: 100,
      rotation: 0,
      image: ""
    }
  },
  methods: {
    /* abrir() {
      this.$refs.dialogoCaptureImage.abrir();
    }, */
    chooseImage() {
      this.$refs.input_foto.value = null;
      this.$refs.input_foto.click();
    },
    changeImage() {
      let file = this.$refs.input_foto.files[0];

      if (file) {
        let reader = new FileReader();
        reader.onload = () => {
          var dataURL = reader.result;
          this.image = dataURL;
          this.$refs.dialogoCaptureImage.abrir();

          this.$nextTick(() => {
            this.zoom = 100;
            this.$refs.clipper.onChange$.subscribe((zoom) => {
              if (zoom > 0) {
                this.zoom = zoom * 100 > 200 ? 200 : zoom * 100;
              }
            });
          });
        };
        reader.readAsDataURL(file);
      }
    },
    captureImage() {
      const canvas = this.$refs.clipper.clip({
        wPixel: 2048,
        maxWPixel: 2048,
      });
      const imageFinal = canvas.toDataURL("image/jpeg");
      this.image = "";
      this.$emit("imagemCapturada", imageFinal);
    },
    fechar() {
      this.$refs.dialogoCaptureImage.fechar();
    }
  }
}
</script>

<style scoped>

</style>

